import { Bancarizadores } from '@/firebase/index';

export default {
  getAll() {
    return Bancarizadores.get();
  },

  async findById(id) {
    try {
      const bancarizadorFromFirebase = await Bancarizadores.doc(id).get();
      var bancarizador = bancarizadorFromFirebase.data();
      if (!bancarizador.id) {
        bancarizador.id = id;
      }
      return bancarizador;
    } catch (error) {
      console.error('bancarizador servic find by id error', error);
      throw Error('Não foi possível consultar os dados do bancarizador.');
    }
  },
};
